import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ErrorDialog = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 2 }}>
          <ErrorOutlineIcon sx={{ fontSize: 60, color: "#d32f2f" }} />
          <DialogTitle sx={{ fontWeight: 700, fontSize: "1.25rem" }}>
            Something went wrong
          </DialogTitle>
          <Typography variant="body1" color="text.secondary">
            {message || "An unexpected error occurred. Please try again later."}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          sx={{ 
            bgcolor: "#1976d2", 
            color: "#fff", 
            px: 4, 
            borderRadius: 2,
            "&:hover": { bgcolor: "#1565c0" }
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
